module.exports = __webpack_public_path__ + "img/stony-tomb-run.e5c264bd.png";